(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.GreeceUpdate",
            {
                url: "/GreeceUpdate",
                component: "greeceUpdate",
                PageTitle: "Greece Convention Update",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("greeceUpdate",
    {
        templateUrl: "App/Resources/GreeceUpdate/GreeceUpdate.template.html",
        controller: greeceUpdateCtrl,
        bindings: {
        }
    });

    greeceUpdateCtrl.$inject = ["amplitudeService"];

    function greeceUpdateCtrl(amplitudeService) {

        var $ctrl = this;
        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
        
    }
    
})(window.app, window.angular); // jshint ignore:line